export const GET_ECONOMIC_INDICATORS = `
    query EconomicIndicators($page: ID){
        economicIndicators(page: $page){
            count
            errors{
                description
                property
            }
            results{
                date
                id
                inflation
                tbill
            }
        }
    }
`;

export const GET_ECONOMIC_INDICATOR = `
    query EconomicIndicator($id: ID!){
        economicIndicator(id: $id){
            date
            id
            inflation
            tbill
        }
    }
`;

export const DELETE_ECONOMIC_INDICATOR = `
    mutation DeleteEconomicIndicator($id: ID!){
        deleteEconomicIndicator(id: $id){
            result
            errors{
                description
                property
            }
        }
    }
`;

export const CREATE_ECONOMIC_INDICATOR = `
    mutation CreateEconomicIndicator($date: ISO8601Date!, $inflation: Float!, $tbill: Float!){
        createEconomicIndicator(date: $date, inflation: $inflation, tbill: $tbill){
            economicIndicator{
                date
                id
                inflation
                tbill
            }
            errors{
                description
                property
            }
        }
    }
`;

export const UPDATE_ECONOMIC_INDICATOR = `
    mutation UpdateEconomicIndicator($id: ID!, $date: ISO8601Date!, $inflation: Float!, $tbill: Float!){
        updateEconomicIndicator(id: $id, date: $date, inflation: $inflation, tbill: $tbill){
            economicIndicator{
                date
                id
                inflation
                tbill
            }
            errors{
                description
                property
            }
        }
    }
`;

export const GET_ASSET_ALLOCATION_ITEMS = `
    query AssetAllocationItems($page: ID){
        assetAllocationItems(page: $page){
            id
            name
        }
    }
`;

export const CREATE_ASSET_ALLOCATION_ITEM = `
    mutation CreateAssetAllocationItem($name: String!){
        createAssetAllocationItem(name: $name){
            assetAllocationItem{
                id
                name
            }
            errors{
                description
                property
            }
        }
    }
`;

export const GET_ASSET_ALLOCATION_ITEM = `
    query AssetAllocationItem($id: ID!){
        assetAllocationItem(id: $id){
            id
            name
        }
    }
`;

export const DELETE_ASSET_ALLOCATION_ITEM = `
    mutation DeleteAssetAllocationItem($id: ID!){
        deleteAssetAllocationItem(id: $id){
            result
            errors{
                description
                property
            }
        }
    }
`;

export const UPDATE_ASSET_ALLOCATION_ITEM = `
    mutation UpdateAssetAllocationItem($id: ID!, $name: String!){
        updateAssetAllocationItem(id: $id, name: $name){
            assetAllocationItem{
                id
                name
            }
            errors{
                description
                property
            }
        }
    }
`;

export const GET_ASSET_ALLOCATION_RATES = `
    query AssetAllocationRates($page: ID){
        assetAllocationRates(page: $page){
            id
            name
        }
    }
`;

export const CREATE_ASSET_ALLOCATION_RATE = `
    mutation CreateAssetAllocationRate($name: String!){
        createAssetAllocationRate(name: $name){
            assetAllocationRate{
                id
                name
            }
            errors{
                description
                property
            }
        }
    }
`;

export const GET_ASSET_ALLOCATION_RATE = `
    query AssetAllocationRate($id: ID!){
        assetAllocationRate(id: $id){
            id
            name
        }
    }
`;

export const DELETE_ASSET_ALLOCATION_RATE = `
    mutation DeleteAssetAllocationRate($id: ID!){
        deleteAssetAllocationRate(id: $id){
            result
            errors{
                description
                property
            }
        }
    }
`;

export const UPDATE_ASSET_ALLOCATION_RATE = `
    mutation UpdateAssetAllocationRate($id: ID!, $name: String!){
        updateAssetAllocationRate(id: $id, name: $name){
            assetAllocationRate{
                id
                name
            }
            errors{
                description
                property
            }
        }
    }
`;

export const GET_QUARTERS = `
    query Quarters($page: ID){
        quarters(page: $page){
            count
            errors{
                description
                property
            }
            results{
                id
                displayName
                startDate
                cediDepreciation
                gdp
                inflation
                tbill91
                tbill182
                tbill365
            }
        }
    }
`;

export const GET_QUARTER = `
    query Quarter($id: ID!){
        quarter(id: $id){
            id
            name
            displayName
            startDate
            endDate
            economicOutlooks {
                id
                outlook
                createdAt
            }
            cediDepreciation
            gdp
            inflation
            tbill91
            tbill182
            tbill365
            assetAllocations{
                assetAllocationItem{
                    id
                    name
                }
                assetAllocationRate{
                    id
                    name
                }
                enable
                id
                order
                product{
                    id
                    name
                }
                quarter{
                    id
                    name
                }
                rate
                order
            }
        }
    }
`;

export const DELETE_QUARTER = `
    mutation DeleteQuarter($id: ID!){
        deleteQuarter(id: $id){
            result
            errors{
                description
                property
            }
        }
    }
`;

export const CREATE_QUARTER = `
    mutation CreateQuarter($startDate: ISO8601Date!, $endDate: ISO8601Date!, $name: String!, $cediDepreciation: Float, $gdp: Float, $inflation: Float, $tbill91: Float, $tbill182: Float, $tbill365: Float){
        createQuarter(startDate: $startDate, endDate: $endDate, name: $name, cediDepreciation: $cediDepreciation, gdp: $gdp, inflation: $inflation, tbill91: $tbill91, tbill182: $tbill182, tbill365: $tbill365){
            quarter{
                id
                name
                startDate
                endDate
                cediDepreciation
                gdp
                inflation
                tbill91
                tbill182
                tbill365
                assetAllocations{
                    assetAllocationItem{
                        id
                        name
                    }
                    assetAllocationRate{
                        id
                        name
                    }
                    enable
                    id
                    order
                    product{
                        id
                        name
                    }
                    quarter{
                        id
                        name
                    }
                    rate
                    order
                }
            }
            errors{
                description
                property
            }
        }
    }
`;

export const UPDATE_QUARTER = `
    mutation UpdateQuarter($id: ID!, $startDate: ISO8601Date!, $endDate: ISO8601Date!, $name: String!, $cediDepreciation: Float, $gdp: Float, $inflation: Float, $tbill91: Float, $tbill182: Float, $tbill365: Float){
        updateQuarter(id: $id, startDate: $startDate, endDate: $endDate, name: $name, cediDepreciation: $cediDepreciation, gdp: $gdp, inflation: $inflation, tbill91: $tbill91, tbill182: $tbill182, tbill365: $tbill365){
            quarter{
                id
                name
                startDate
                endDate
                cediDepreciation
                gdp
                inflation
                tbill91
                tbill182
                tbill365
                assetAllocations{
                    assetAllocationItem{
                        id
                        name
                    }
                    assetAllocationRate{
                        id
                        name
                    }
                    enable
                    id
                    order
                    product{
                        id
                        name
                    }
                    quarter{
                        id
                        name
                    }
                    rate
                    order
                }
            }
            errors{
                description
                property
            }
        }
    }
`;

export const CREATE_ASSET_ALLOCATION = `
    mutation createAssetAllocation($quarterId: ID!, $productId: ID!, $assetAllocationItemId: ID!, $assetAllocationRateId: ID!, $enable: Boolean!, $order: String!, $rate: Float!) {
        createAssetAllocation(quarterId: $quarterId, productId: $productId, assetAllocationItemId: $assetAllocationItemId, assetAllocationRateId: $assetAllocationRateId, enable: $enable, order: $order, rate: $rate) {
            assetAllocation{
                assetAllocationItem{
                    id
                    name
                }
                assetAllocationRate{
                    id
                    name
                }
                enable
                id
                order
                product{
                    id
                    name
                }
                quarter{
                    id
                    name
                }
                rate
                order
            }
            errors{
                description
                property
            }
        }
    }
`

export const GET_ASSET_ALLOCATION =`
    query AssetAllocation($id: ID!){
        assetAllocation(id: $id){
            assetAllocationItem{
                id
                name
            }
            assetAllocationRate{
                id
                name
            }
            enable
            id
            order
            product{
                id
                name
            }
            quarter{
                id
                name
            }
            rate
            order
        }
    }
`

export const UPDATE_ASSET_ALLOCATION = `
    mutation UpdateAssetAllocation($id: ID!, $quarterId: ID!, $productId: ID!, $assetAllocationItemId: ID!, $assetAllocationRateId: ID!, $enable: Boolean!, $order: String!, $rate: Float!) {
        updateAssetAllocation(id: $id, quarterId: $quarterId, productId: $productId, assetAllocationItemId: $assetAllocationItemId, assetAllocationRateId: $assetAllocationRateId, enable: $enable, order: $order, rate: $rate) {
            assetAllocation{
                assetAllocationItem{
                    id
                    name
                }
                assetAllocationRate{
                    id
                    name
                }
                enable
                id
                order
                product{
                    id
                    name
                }
                quarter{
                    id
                    name
                }
                rate
                order
            }
            errors{
                description
                property
            }
        }
    }
`

export const DELETE_ASSET_ALLOCATION = `
    mutation DeleteAssetAllocation($id: ID!){
        deleteAssetAllocation(id: $id){
            result
            errors{
                description
                property
            }
        }
    }
`;